import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { IWellKnownUpdateDomainsPayload } from '../types';
import {
  WELL_KNOWN_DOMAINS_LIST_QUERY_KEY,
  WELL_KNOWN_LINKS_LIST_QUERY_KEY,
  WELL_KNOWN_LINKS_PERMISSIONS,
  WELL_KNOWN_LINKS_UPDATE_DOMAINS_API_URL,
  WELL_KNOWN_LINKS_UPDATE_DOMAINS_MUTATION_KEY,
} from '../constants';

export default function useUpdateDomainsMutation(): IContextMutationResult<void, Error, IWellKnownUpdateDomainsPayload> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IWellKnownUpdateDomainsPayload>({
    mutationKey: [WELL_KNOWN_LINKS_UPDATE_DOMAINS_MUTATION_KEY],
    mutationFn: ({ id, ...payload }) => fetchPut<void>(
      WELL_KNOWN_LINKS_UPDATE_DOMAINS_API_URL,
      payload,
      {
        permission: WELL_KNOWN_LINKS_PERMISSIONS.EDIT,
        urlParams: {
          id,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [WELL_KNOWN_LINKS_LIST_QUERY_KEY] });
      await queryClient.invalidateQueries({ queryKey: [WELL_KNOWN_DOMAINS_LIST_QUERY_KEY] });
      displayPresetToast('edited');
    },
  });
}
